import { Extension } from '@tiptap/core'
import { Plugin, PluginKey } from '@tiptap/pm/state'
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import TCVelikClient from '@/TCVelikClient/TCVelikClient';

export const AIMenuExtension = Extension.create({
  name: 'aiMenu',

  addOptions() {
    return {
      onAsk: ({ prompt, range, editor }) => {
        console.log("ASKING ...", prompt, range, editor);
      },
    }
  },

  addProseMirrorPlugins() {
    const extensionThis = this

    return [
      new Plugin({
        key: new PluginKey('ai-menu'),
        view(editorView) {
          let popup = null;
          let menu = null;
          let highlights = [];
          let currentChat = null;

          let lastRange = {
            from: null,
            to: null,
            isEmpty: true,
            text: ''
          };

          const selectionInterval = setInterval(() => {

            const { selection } = editorView.state

            //console.log(JSON.stringify(lastRange));

            if (selection.empty) {
              hideMenu()
              return
            }

            // If selection changed
            if (!lastRange ||
              lastRange.from !== selection.$from.pos ||
              lastRange.to !== selection.$to.pos) {

              lastRange = {
                from: selection.$from.pos,
                to: selection.$to.pos,
                text: editorView.state.doc.textBetween(selection.$from.pos, selection.$to.pos),
                isEmpty: false
              }

              createHighlight(selection);

              if (!menu) {
                menu = createMenu()
              }

              const start = editorView.coordsAtPos(selection.from);
              const end = editorView.coordsAtPos(selection.to);
              const editorRect = editorView.dom.getBoundingClientRect();

              menu.style.top = `${end.bottom - editorRect.top + 5}px`;
              menu.style.left = `${start.left - editorRect.left}px`;
              menu.style.display = "block";
              menu.classList.add('visible', 'buttons-only');
            }

            //}
          }, 50)

          function createMenu() {

            const menuDiv = document.createElement('div')
            menuDiv.className = 'ai-menu buttons-only'

            const closeButton = document.createElement('div')

            const askButton = document.createElement('button')
            askButton.id = 'askAiButton'
            askButton.textContent = 'Ask AI'
            askButton.onclick = showInput;
            askButton.classList.add("btn", "btn-primary");

            const input = document.createElement('input')
            input.type = 'text'
            input.id = 'enquiry'
            input.placeholder = 'Ask AI something...'
            input.style.display = 'none';
            input.classList.add("vs-inputx", "vs-input--input", "normal");

            const submitButton = document.createElement('button')
            submitButton.id = 'submitButton'
            submitButton.textContent = 'Submit'
            submitButton.style.display = 'none'
            submitButton.onclick = handleAskAI
            submitButton.style.float = "right";
            submitButton.classList.add("btn", "btn-primary");


            menuDiv.appendChild(closeButton)
            menuDiv.appendChild(askButton)
            menuDiv.appendChild(input)
            menuDiv.appendChild(submitButton)

            input.addEventListener('keydown', (e) => {
              if (e.key === 'Enter') {
                e.preventDefault()
                handleAskAI()
              }
              if (e.key === 'Escape') {
                e.preventDefault()
                hideMenu()
              }
            })

            const editorWrapper = editorView.dom.parentElement
            editorWrapper.appendChild(menuDiv);

            return menuDiv
          }

          function createHighlight(selection) {
            clearHighlights()
            const view = editorView
            const editorEl = view.dom
            const editorRect = editorEl.getBoundingClientRect()
            const editorWrapper = editorEl.parentElement
            editorWrapper.style.position = 'relative'

            // Step through each position in the selection
            let pos = selection.from
            let lastTop = null

            while (pos <= selection.to) {
              const coords = view.coordsAtPos(pos)

              // If we're on a new line (different top position)
              if (lastTop !== coords.top) {
                // Find the end of this line
                let endPos = pos
                while (endPos < selection.to) {
                  const nextCoords = view.coordsAtPos(endPos + 1)
                  if (nextCoords.top !== coords.top) break
                  endPos++
                }

                // Create highlight for this line
                const endCoords = view.coordsAtPos(endPos)
                const highlight = document.createElement('div')
                highlight.className = 'selection-highlight'
                highlight.style.position = 'absolute'
                highlight.style.left = (coords.left - editorRect.left) + 'px'
                highlight.style.top = (coords.top - editorRect.top) + 'px'
                highlight.style.width = (endCoords.right - coords.left) + 'px'
                highlight.style.height = (coords.bottom - coords.top) + 'px'

                editorWrapper.appendChild(highlight)
                highlights.push(highlight)

                lastTop = coords.top
                pos = endPos + 1
              } else {
                pos++
              }
            }
          }


          function clearHighlights() {
            highlights.forEach(h => h.remove())
            highlights = []
          }

          function hideMenu() {
            //menu.remove()
            if (menu) {
              menu.style.display = "none";
              menu.classList.remove('visible', 'buttons-only', 'with-input')
              const input = menu.querySelector('#enquiry')
              const submitButton = menu.querySelector('#submitButton')
              const askButton = menu.querySelector('#askAiButton')

              //menu.style.display = 'none';

              if (input) {
                input.value = ''
                input.style.display = 'none'
              }

              if (submitButton) submitButton.style.display = 'none'
              if (askButton) askButton.style.display = 'block'
            }

            clearHighlights()
          }

          function showInput() {
            menu.classList.remove('buttons-only')
            menu.classList.add('with-input')

            const askButton = menu.querySelector('#askAiButton')
            const input = menu.querySelector('#enquiry')
            const submitButton = menu.querySelector('#submitButton')

            if (askButton) askButton.style.display = 'none'
            if (input) input.style.display = 'block'
            if (submitButton) submitButton.style.display = 'block'

            const { from, to } = editorView.state.selection
            lastRange = {
              startOffset: from,
              endOffset: to,
              text: editorView.state.doc.textBetween(from, to),
              isEmpty: false
            }

            if (input) input.focus()
          }

          function handleAskAI() {
            const input = menu.querySelector('#enquiry')
            if (!input || !input.value.trim()) return

            const prompt = input.value

            if (lastRange && !lastRange.isEmpty) {
              extensionThis.options.onAsk({
                prompt,
                range: {
                  from: lastRange.from,  // Changed from startOffset
                  to: lastRange.to       // Changed from endOffset
                },
                editor: extensionThis.editor
              })

              var payload = {
                InputTokens: 0,
                OutputTokens: 0,
                Messages: [
                  {
                    Role: "System",
                    Content: "ALWAYS DIRECTLY OUTPUT RAW HTML! DO NOT ADD EXPLANATIONS OR COMMENTS TO IT, DO NOT WRAP IT IN ANYTHING.\n EITHER THE RAW HTML OUTPUT OR NOTHING. YOU ARE AN AI TOOL THAT HELPS USERS IMPROVE SOPs. AN SOP IS AN HTML and CAN USE THE FOLLOWING TAGS: H, A, IMG, STRONG TABLE, IN ADDITION ACTIONABLE ACTIONABLE STEPS ARE USING THIS HTML, USE IT WHEN YOU ARE ASKED TO IMPROVE SOP OR ADD STEP OR SOMETHING SIMILAR: <div data-type='draggable-item' data-subtype=\"default\" data-temp-step-id=\"RANDOM-ID-HERE\"><p><strong>STEP TITLE</strong></p><p>STEP CONTENT</p><p></p></div>, WHERE STEP TITLE is the title for the step, it has to be simple text, no special tags.\nSTEP CONTENT is the content. Step content CANNOT HAVE P tags in it and should always go in the second P, do not move it. The 3rd P in the template is reserved, YOU CAN STILL USE BR TO ACHIEVE PARAGRAPHS WHERE NEEDED, LISTS ARE ALSO ALLOWED. Help the user achieve their goals. ONLY RETURN HTML ACCORDING TO THE SPECIFICATION ABOVE. Do not add arbitrary comments as the get included in the HTML (WRONG)."
                  },
                  {
                  Role: "User",
                    Content: prompt + extensionThis.editor.getHTML()
                }]
              };

              var options = {
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                }
              };

              TCVelikClient.PostRelative("/api/OpenAI/ChatWithFunctions", payload, options).then(function (response) {
                if (response && response.data && response.data) {

                  try {
                    var newText = JSON.parse(response.data.Messages[response.data.Messages.length - 1].Content);
                    extensionThis.editor
                      .chain()
                      .focus()
                      .setContent(newText[0].Text)
                      .run();
                  }
                  catch (err) {
                    alert('Something happened...');
                  }
                }
              });

              hideMenu();
              lastRange = null;
            }

            hideMenu()
          }

          return {
            destroy() {
              if (menu) {
                menu.remove()
                menu = null
              }
              clearHighlights()
            }
          }
        }
      })
    ]
  }
})
